import { debug, extractRequestMetadata, makeCookieSessionStorage, makeSrvLgApiConnector, } from "@lg-plus/landing-modules";
export async function submitHandler(req, res) {
    if (req.method !== "POST") {
        res.status(405).end(); // Method Not Allowed
        return;
    }
    debug("Form submitted:", req.body);
    const { formKey, data } = req.body;
    if (!formKey || !data) {
        res.status(400).end();
        return;
    }
    const sessionStorage = makeCookieSessionStorage(req, res);
    const connector = makeSrvLgApiConnector();
    //TODO: handle possible exception?
    const apiCallResult = await connector.triggerSubmitted(formKey, data, {
        sessionToken: sessionStorage.load() || "",
        request: extractRequestMetadata(req),
    });
    if (apiCallResult.sessionToken) {
        sessionStorage.store(apiCallResult.sessionToken);
    }
    res.status(200).json(apiCallResult);
    debug("API response:", apiCallResult);
}
